import api from './api';

export const locationService = {
  getProvinces: async () => {
    const response = await api.get('/public/provinces');
    return response.data?.data?.provinces || [];
  },

  getDistricts: async (provinceId, options = {}) => {
    const params = {};
    if (provinceId) params.province_id = provinceId;
    if (options.withZone) params.with_zone = 'true';
    const response = await api.get('/public/districts', { params });
    return response.data?.data?.districts || [];
  },
};
